import { MasterDataService } from 'src/app/services/master-data.service';
import { Component, OnInit, Input } from '@angular/core';
import { NgModel } from '@angular/forms';
import * as moment from 'moment';
import * as html2pdf from 'html2pdf.js';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { BranchFilterService } from 'src/app/services/branch-filter.service';

@Component({
  selector: 'app-article-one-sixth-report',
  templateUrl: './article-one-sixth-report.component.html',
  styleUrls: ['./article-one-sixth-report.component.css'],
})
export class ArticleOneSixthReportComponent implements OnInit {
  @Input() isMyReport = false;
  @Input() reportList;
  @Input() showReportDetail = false;

  branchList;
  selectedBranch;
  isBranchSelected = false;
  selectedPartner;
  partnerList;
  selectedUser;
  userList;
  selectedDate;
  display = 0;
  eligibilityOfCAExamLeaveInDaysIntegerValue;
  ICAIRegDate;
  userRole;
  accessResponse: any;

  constructor(private masterDataService: MasterDataService,
    private commonMessageService: CommonMessageService, private branchFilterService: BranchFilterService) { }

  ngOnInit(): void {
    this.selectedPartner = '';
    this.selectedUser = '';
    if (!this.isMyReport) {
      this.loadInitialDetails();
    }
  }
  loadInitialDetails() {
    // this.masterDataService.getBranch().subscribe((res) => {
    //   this.branchList = res;
    // });
    this.accessResponse = JSON.parse(localStorage.getItem('accessResponse'));
    this.masterDataService.getBranch().subscribe((res) => {
      const branches = res as any[];
      const userBranchId = Number(localStorage.getItem('branchId'));

      this.branchList = this.branchFilterService.getFilteredBranches(branches, this.accessResponse, userBranchId);
    });
  }

  selectAllBranch(select: NgModel, values) {
    this.selectAll(select, values, this.isBranchSelected, false);
    this.isBranchSelected = !this.isBranchSelected;
    this.onPartnerSelected();
  }
  selectAll(select: NgModel, values, isSelected, isId) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }
  selectBranch() {
    this.selectedPartner = '';
    if (this.selectedBranch.length != 0 && this.selectedBranch != undefined) {
      this.onPartnerSelected();
    }
  }

  onPartnerSelected() {
    const branchId = this.selectedBranch.map(({ id }) => id);
    this.masterDataService
      .getUserPartnersOfBranch(branchId)
      .subscribe((res) => {
        console.log('select partner', res);
        this.partnerList = res;
      });
  }
  onUserSelected() {
    this.selectedUser = '';
    if (
      this.selectedPartner != '' &&
      this.selectedPartner != undefined &&
      this.selectedPartner != null
    ) {
      this.masterDataService
        .getUsersOfPartner(this.selectedPartner.id)
        .subscribe((res) => {
          console.log('userList', res);
          this.userList = res;
        });
    }
  }

  selectedUserName(selectedUser) {
    this.userList.map((res) => {
      if (res.id == selectedUser.id) {
        this.ICAIRegDate = moment(res.icaiRegistrationDate).format(
          'DD-MMMM-YYYY'
        );
      }
    });
  }

  formatDate;
  onViewReport() {
    if (
      this.selectedBranch == null ||
      this.selectedBranch.length === 0 ||
      this.selectedPartner == '' ||
      this.selectedPartner == undefined ||
      this.selectedPartner == null ||
      this.selectedUser == '' ||
      this.selectedUser == undefined ||
      this.selectedUser == null ||
      this.selectedDate == '' ||
      this.selectedDate == undefined ||
      this.selectedDate == null
    ) {
      this.commonMessageService.swalAlertWithoutIcon('', 'Please choose the values before pressing report');
      this.showReportDetail = false;
      this.reportList = null;
      return;
    }
    var entryDate1 = new Date(
      this.selectedDate.year +
      '-' +
      this.selectedDate.month +
      '-' +
      this.selectedDate.day
    );
    console.log('entrydate', entryDate1);
    this.formatDate = moment(entryDate1).format('YYYY-MM-DD');
    console.log('format date', this.formatDate);

    this.masterDataService
      .getOneSixthReport(this.selectedUser.id, this.formatDate)
      .subscribe((res) => {
        this.showReportDetail = false;
        this.reportList = res;
        console.log('reportList', res);
        if (this.reportList != null) {
          this.eligibilityOfCAExamLeaveInDaysIntegerValue = parseInt(
            this.reportList.eligibilityOfCAExamLeaveInDays
          );
          this.showReportDetail = true;
        } else {
          this.commonMessageService.swalAlertWithoutIcon('', "No Record Found");
          this.showReportDetail = false;
          this.reportList = null;
        }
      });
  }

  exportToExcelClick() {
    this.masterDataService
      .getOneSixthReportExcel(this.selectedUser.id, this.formatDate)
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "ArticleOneSixthReport.xlsx";
        link.click();
      });
  }

  exportToPDFClick() {
    var element = document.getElementById('elementsForPDF');
    var opt = {
      //  margin:  1,
      filename: 'ArticleOneSixthReport.pdf',
      image: { type: 'jpeg' },
      html2canvas: {},
      jsPDF: { unit: 'mm', format: 'letter', orientation: 'landscape' }
    };

    // html2pdf().set({
    //   pagebreak: { mode: 'avoid-all', before: '#forPageBreak' }
    // });

    html2pdf().from(element).set(opt).save();

  }
}
